const BASE_URL = process.env.REACT_APP_API;

export async function request(endpoint, method = 'GET', body = null) {
    const config = {
        method,
        headers: {
            'Content-Type': 'application/json'
        }
    };

    if (body && method !== 'GET') {
        config.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(`${BASE_URL}/${endpoint}`, config);
        if (!response.ok) throw new Error(`Erro ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error(`Erro na requisição [${method}] para ${endpoint}:`, error);
        throw error;
    }
}

export const enviarMensagem = (body) => request('mensagens/envios', 'POST', body);
